import { useState } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { faqs } from '../../../mocks/contacto';
import { getAdminData } from '../../../hooks/useAdminData';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqList = getAdminData<FAQItem[]>('admin_contact_faqs', faqs);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section ref={ref} className="w-full bg-brand-cream py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-14" style={style}>
            <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
              FAQ
            </span>
            <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
              Preguntas <span className="italic text-brand-gray-300">frecuentes</span>
            </h2>
            <p className="font-sans text-brand-gray-500 text-base leading-[1.8] mt-5">
              Resolvemos las dudas más comunes sobre nuestros servicios, reservas y procesos.
            </p>
          </div>

          <div className="space-y-4">
            {faqList.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden"
                style={isVisible ? {
                  opacity: 1,
                  transform: 'translateY(0px)',
                  transition: `opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 80}ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 80}ms`,
                } : {
                  opacity: 0,
                  transform: 'translateY(24px)',
                  transition: `opacity 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 80}ms, transform 800ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 80}ms`,
                  willChange: 'opacity, transform',
                }}
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex items-center justify-between p-6 md:p-8 text-left"
                >
                  <span className="font-serif text-brand-black text-base md:text-lg font-medium pr-4">
                    {faq.question}
                  </span>
                  <div className="w-8 h-8 rounded-full bg-brand-gray-50 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`ri-arrow-down-s-line text-brand-black transition-transform duration-300 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    />
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    openIndex === index ? 'max-h-[500px]' : 'max-h-0'
                  }`}
                >
                  <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.8] px-6 md:px-8 pb-6 md:pb-8">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}